import { Divider } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import LoadingIndicator from '../common/LoadingIndicator';
import MobxContext from '../mobx/MobxContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 8
    },
    sectionHeader: {
      marginBottom: 8,
    },
    largeGutter: {
      marginBottom: 16
    },
    section: {
      marginBottom: 32
    },
    panel: {
      padding: 24,
      backgroundColor: theme.palette.background.paper,
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
    }
  })
);

interface Props {
  family: any;
}

function FamilySettings(props: Props) {
  const { family } = props;
  const classes = useStyles({});
  const { cspGroupStore } = useContext(MobxContext);

  return cspGroupStore.groups ? (
    <div className={classes.root}>
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <Typography color="textSecondary" variant="h6">Family Admins</Typography>
        </div>
        <div className={classes.panel}>
          <Typography color="textSecondary" className={classes.largeGutter}>
            Only the family creator and members of the groups below can edit this family.
          </Typography>
          <TableContainer>
            <Divider light />
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography>{family.Owner}</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Chip label="Owner" variant="outlined" color="primary" size="small" />
                  </TableCell>
                </TableRow>
                {family.Groups.FamilyAdmins && family.Groups.FamilyAdmins.map(group => <TableRow key={group}>
                  <TableCell>
                    <Typography>{cspGroupStore.groups[group]} ({group})</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Chip label="Group" variant="outlined" color="primary" size="small" />
                  </TableCell>
                </TableRow>)}
              </TableBody>
            </Table>

          </TableContainer>
        </div>
      </div>
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <Typography color="textSecondary" variant="h6">Workflow Access Permissions</Typography>
        </div>
        <div className={classes.panel}>
          <Typography color="textSecondary" className={classes.largeGutter}>
            The following IAM ARNs can edit and execute any workflow in this family.
          </Typography>
          {family.AllowedARNs && family.AllowedARNs.length > 0 && <TableContainer>
            <Divider light />
            <Table>
              <TableBody>
                {family.AllowedARNs && family.AllowedARNs.map(arn => <TableRow key={arn}>
                  <TableCell>
                    <Typography>{arn}</Typography>
                  </TableCell>
                </TableRow>)}
              </TableBody>
            </Table>
          </TableContainer>}
          {(!family.AllowedARNs || family.AllowedARNs.length === 0) && <Typography color="textSecondary">None</Typography>}
        </div>
      </div>
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <Typography color="textSecondary" variant="h6">Notifications</Typography>
        </div>
        <div className={classes.panel}>
          <Typography color="textSecondary" gutterBottom>
            SNS Topic you can subscribe to for notifications when executions in this family complete
          </Typography>
          <Typography>{family.NotificationTopicARN}</Typography>
        </div>
      </div>
    </div>
  ) : <LoadingIndicator loading={true} />;
};

export default observer(FamilySettings);
